const AdminActionType = {
    AdminDash:"ADMIN_DASH"
}

export default AdminActionType